<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-3 col-sm-4">
                
              </div>
              <div class="col-md-9 col-sm-8">
                <div class="d-flex justify-content-end" v-if="modesOfPaymentModule.access.create">
                  <div class="me-2">
                    <router-link :to="{ name: 'MainModeForm', params: { mopId: 0, mode: 'add' }}">
                      <b-button variant="primary"><i class="uil uil-plus me-1"></i>Mode of Payment</b-button>
                    </router-link>
                  </div>
                  <div class="me-2">
                    <router-link :to="{ name: 'ModuleModeForm', params: { methodId: 0, mode: 'add' }}">
                      <b-button variant="primary"><i class="uil uil-plus me-1"></i>Module Mode</b-button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <b-tabs
              v-model="activeTab"
              content-class="p-3 text-muted"
              nav-class="nav-tabs-custom"
            >
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Mode of Payment</span>
                </template>
                <main-mode-list></main-mode-list>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Modules</span>
                </template>
                <module-mode-list></module-mode-list>
              </b-tab>
              <b-tab
                @click="() => { this.$refs.reasonLog.onRefresh() }">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Logs</span>
                </template>
                <reason-log-list ref="reasonLog"></reason-log-list>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods } from '@/state/helpers';
import MainModeList from '@/views/pages/mode-of-payment/MainModeList.vue';
import ModuleModeList from '@/views/pages/mode-of-payment/ModuleModeList.vue';
import ReasonLogList from '@/views/pages/mode-of-payment/ReasonLogList.vue';
import { getModuleAccess } from '@/router/helper.js';

export default {
  data(){
    return {
      activeTab: 0,
      recordCount: 0,
      modesOfPaymentModule: {
				access: {
					create: false,
          read: false,
          update: false,
          delete: false
				}
			}
    }
  },
  components: {
    MainModeList,
    ModuleModeList,
    ReasonLogList
  },
  methods: {
    ...layoutMethods,
    changeTab(tabIndex){
      var _this = this;
      setTimeout(function(){
        _this.activeTab = tabIndex;
      },200);
    }
  },
  async mounted(){
    this.changeTitle({title: 'E-Load Top-up Mode of Payment'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Load Core Manager', to: { name: 'Home'} },
        { text: 'E-Load Top-up Mode of Payment', to: { name: 'Mode of Payment'} }
      ]
    });

    if(location.hash == '#module'){
      this.changeTab(1);
    } else {
      this.changeTab(0);
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'Modes of Payment')
      .then((access) => this.modesOfPaymentModule.access = access);

  }
};
</script>

<style>
</style>